import EChartsReact from 'echarts-for-react';
import React from 'react';
import { getValueFromPercent } from 'utils/helpers';
interface IProps {
    showLabel: boolean;
    total: number;
    data: {
        indicator: { name: string }[];
        legend: string[];
        data: {
            name: string;
            value: number[];
        }[];
    };
}
const QuestionRadarChart: React.FC<IProps> = ({ showLabel, data, total }) => {
    const option = {
        tooltip: {
            trigger: 'item',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formatter: function (params: any) {
                const values = params.value;
                let tooltip = `
      <span style="display:inline-block;margin-right:5px;
        border-radius:10px;width:10px;height:10px;
        background-color:${params.color}"></span>
      <b>${params.name}</b><br/>
    `;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                values.forEach((val: any, i: number) => {
                    tooltip += `${data.indicator[i].name}: ${getValueFromPercent(val, total, 0)}<br/>`;
                });
                return tooltip;
            },
        },
        legend: {
            data: data.legend ?? [],
            icon: 'circle',
            type: 'scroll',
        },

        radar: {
            indicator: data?.indicator?.map((item) => {
                return {
                    name: item.name,
                    max: data?.data
                        ?.map((item) => item.value)
                        ?.reduce((max, current) => {
                            return Math.max(max, Math.max(...current));
                        }, 0),
                };
            }),
            axisLabel: {
                formatter: function (value: number) {
                    return value.toFixed(0);
                },
                color: 'black',
            },
        },
        series: [
            {
                name: 'Thông tin',
                type: 'radar',
                data: data?.data?.map((item) => {
                    return {
                        value: item?.value?.map((val) => val ?? 0),
                        name: item.name,
                    };
                }),
                label: {
                    show: showLabel,
                    formatter: (params: { value: number }) => {
                        return params.value + '%';
                    },
                    color: '#000',
                    fontSize: 12,
                },
            },
        ],
    };

    return (
        <>
            <EChartsReact
                notMerge={true}
                style={{ height: '600px' }}
                option={option}
            />
        </>
    );
};

export default QuestionRadarChart;
